import { Outlet, useLocation } from 'react-router-dom';
import { useRef } from 'react';
import Topbar from '@/components/admin/Topbar';
import ClientMobileTopbar from '@/components/client/mobile/ClientMobileTopbar';
import ClientMobileBottomNav from '@/components/client/mobile/ClientMobileBottomNav';
import SidebarClient from './SidebarClient';
import SidebarCommunity from './SidebarCommunity';
import SEO from '@/components/common/SEO';
import { ScrollContainerProvider } from '@/contexts/ScrollContainerContext';
import { useSidebar } from '@/contexts/SidebarContext';
import { useAuth } from '@/contexts/AuthContext';
import { isCommunityDetailPath, isPublicProfilePath } from '@/utils/clientPaths';

const ClientBlankLayout = () => {
  const { isCollapsed } = useSidebar();
  const { user } = useAuth();
  const location = useLocation();
  const mobileMainRef = useRef<HTMLElement>(null);
  const pathname = location.pathname;

  const isCommunityUser =
    user?.role === 'community' ||
    (typeof localStorage !== 'undefined' && localStorage.getItem('sporto_role') === 'community');
  const isNoTopbar = isPublicProfilePath(pathname) || isCommunityDetailPath(pathname);

  return (
    <>
      <SEO
        title={isCommunityUser ? 'Sporto Community' : 'Sporto Client'}
        description={isCommunityUser ? 'Dashboard community Sporto' : 'Dashboard pengguna Sporto'}
        url={isCommunityUser ? '/host' : '/'}
        noIndex={true}
      />
      {/* Desktop and Tablet Layout */}
      <div className="hidden md:flex min-h-screen bg-gray-50">
        <aside
          className={`shrink-0 bg-white border-r transition-[width] duration-300 ease-in-out relative z-20 ${
            isCollapsed ? 'w-20' : 'w-64'
          }`}
        >
          {isCommunityUser ? <SidebarCommunity /> : <SidebarClient />}
        </aside>
        <div className="flex-1 flex flex-col">
          {!isNoTopbar && <Topbar page={isCommunityUser ? 'community' : 'client'} />}
          <main className="p-6 flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden min-h-screen flex flex-col ">
        <ClientMobileTopbar />

        <ScrollContainerProvider value={mobileMainRef}>
          <main
            ref={mobileMainRef}
            className="flex-1 overflow-auto"
          >
            <Outlet />
          </main>
        </ScrollContainerProvider>

        <ClientMobileBottomNav />
      </div>
    </>
  );
};

export default ClientBlankLayout;
